const terms = {
	es: {
		rights: 'Todos los derechos reservados',
		termsConditions: {
			label: 'Términos y condiciones',
			url: 'terminos-y-condiciones'
		},
		privacyPolicy: {
			label: 'Política de privacidad',
			url: 'politicas-de-privacidad'
		},
		cookiePolicy: {
			label: 'Cookies',
			url: '#'
		}
	},
	en: {
		rights: 'All Rights Reserved',
		termsConditions: {
			label: 'Terms and Conditions',
			url: 'terms-and-conditions'
		},
		privacyPolicy: {
			label: 'Privacy Policy',
			url: 'privacy-policy'
		},
		cookiePolicy: {
			label: 'Cookies',
			url: '#'
		}
	},
	pt: {
		rights: 'Todos os direitos reservados',
		termsConditions: {
			label: 'Termos e condições',
			url: 'termos-e-condicoes'
		},
		privacyPolicy: {
			label: 'Política de privacidade',
			url: 'politica-de-privacidade'
		},
		cookiePolicy: {
			label: 'Cookies',
			url: '#'
		}
	}
}

export { terms };